import {
  CurrentStageAndConfig,
  currentHost,
  getCurrentStageAndConfig,
} from "../StageConfig";
import { apiEndpoints, queryParams } from "../constants/ApiConstants";
import axios from "axios";
import { appendRefMarkers } from "../utils/RefMarkersConfig";

const fallbackErrorPage = `https://${currentHost}/error`

export async function loginUser(): Promise<any> {
  const { config: currentStage }: CurrentStageAndConfig =
    getCurrentStageAndConfig();

  const authPortalUrlReq = {
    domain: currentStage.domain,
    associationHandle: currentStage.associationHandle,
    returnToUrl: appendRefMarkers(currentStage.returnToUrl),
    pageId: currentStage.pageId,
  };

  const authHeaders = {
    headers: {
      AuthPortalUrlRequest: JSON.stringify(authPortalUrlReq),
    },
  };
  try {
    const response = await axios.post(
      `${currentStage.smartPosUrl}${apiEndpoints.login}${queryParams.posSession}`,
      {},
      authHeaders
    );
    return response?.data;
  } catch (error: any) {
    const { status } = error?.response;
    const statusValue = [401, 403, 404, 500]
    if (status === statusValue?.includes(status))
      window.location.replace(fallbackErrorPage);
  }
}
export const redirectToSignInPage = async () => {
  const res = await loginUser();
  if (res) return window.location.replace(res?.redirectUrl);
  window.location.replace(fallbackErrorPage);
};